import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
/* Styles go here */
.manager {
    display: flex;
    position: relative;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
}
.title {
    text-transform: uppercase;
    font-size: 14px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    margin-bottom: 8px;
    /*word-wrap: break-word;*/
}
.detail {
  font-family: 'Nimbus Sans Light', sans-serif;
  font-weight: normal;
}
img {
    height: 240px;
    max-width: 160px;
    display: block;
}
figure {
    margin: 0;
    max-width: 160px;
    border: 1px solid #b8b8b8;
    box-sizing: initial;
}
figcaption {
    background-image: linear-gradient(115deg, #054c70, #086ea1);
    color: #ffffff;
    padding: calc(24px / 2);
    font-size: 14px;
  font-family: 'Nimbus Sans Light', sans-serif;
  font-style: normal;
}
figcaption strong {
    font-size: 14px;
    text-transform: uppercase;
}
.bio {
    margin: calc(24px / 2);
    line-height: 1.43;
    font-size: 14px;
    height: -webkit-max-content;
    height: max-content;
    color: #898989;
    /* seems not very accesible */
    border-bottom: 1px solid #b3b3b3;
    border-top: 1px solid #b3b3b3;
    margin-top: 0;
    padding-top: 24px;
}
.bio strong {
    color: #000000;
    font-size: 20px;
}
.name {
    margin-bottom: calc(8px * 2);
    font-size: 20px;
    color: #3b3b3b;
}
.education {
    margin-bottom: 24px;
}
`;

export default styles;